<template>
  <p>
    {{
      translate(
        'Login policies restrict how users with an email in the registered domains list can sign in to Sphere and our support portal.',
      )
    }}
  </p>
  <p v-if="loginPolicyStore.domainsLoaded && loginPolicyStore.domains.length === 0">
    {{
      translate("You have not yet verified a domain name, so you can't activate login policies.")
    }}
  </p>
  <LoginPolicyDataTable
    :title="translate('Login Policies')"
    :loading="loginPolicyStore.loginPoliciesLoading"
    :login-policies="loginPolicyStore.loginPolicies"
    :style="{marginTop: '2em', marginBottom: '2em'}"
    @create-new="createNew"
    @activate="(id: string) => (activateThisPolicyId = id)"
    @edit="editPolicy"
    @edit-as-new="editPolicyAsNew"
    @view="viewPolicy"
    @delete="(lp: string) => (deleteThisPolicyId = lp)"
    @deactivate="(lp: string) => (deactivateThisPolicyId = lp)"
  />
  <ConfirmCreatePolicyDialog
    v-if="showConfirmCreateDialog"
    @close="showConfirmCreateDialog = false"
    @confirm="confirmCreateNew"
  />
  <ActivateLoginPolicyDialog
    v-if="activateThisPolicy"
    :activate-policy="activateThisPolicy"
    :deactivate-policy="loginPolicyStore.loadedActivePolicy()"
    @close="activateThisPolicyId = undefined"
  />
  <LoginPolicyDialog
    v-if="selectedPolicy"
    :login-policy="selectedPolicy"
    :open-read-only="openReadOnly"
    @close="selectedPolicyId = undefined"
  />
  <DeleteLoginPolicyDialog
    v-if="deleteThisPolicy"
    :login-policy="deleteThisPolicy"
    @close="deleteThisPolicyId = undefined"
  />
  <DeactivateLoginPolicyDialog
    v-if="deactivateThisPolicy"
    :login-policy="deactivateThisPolicy"
    @close="deactivateThisPolicyId = undefined"
  />
</template>
<script setup lang="ts">
const loginPolicyStore = useLoginPolicyStore();
const {translate} = useLocalisation();

const showConfirmCreateDialog = ref(false);

const activateThisPolicyId = ref<string>();
const activateThisPolicy = computed(
  () => activateThisPolicyId.value && loginPolicyStore.loadedPolicyById(activateThisPolicyId.value),
);

const selectedPolicyId = ref<string>();
const openReadOnly = ref(false);
const selectedPolicy = computed(
  () => selectedPolicyId.value && loginPolicyStore.loadedPolicyById(selectedPolicyId.value),
);

const deleteThisPolicyId = ref<string>();
const deleteThisPolicy = computed(
  () => deleteThisPolicyId.value && loginPolicyStore.loadedPolicyById(deleteThisPolicyId.value),
);

const deactivateThisPolicyId = ref<string>();
const deactivateThisPolicy = computed(
  () =>
    deactivateThisPolicyId.value && loginPolicyStore.loadedPolicyById(deactivateThisPolicyId.value),
);

function createNew() {
  if (loginPolicyStore.loginPoliciesLoaded && loginPolicyStore.loginPolicies.length === 0) {
    // Skip confirmation dialog if we know there's no policy yet
    confirmCreateNew();
  } else {
    showConfirmCreateDialog.value = true;
  }
}

async function confirmCreateNew() {
  const lp = await loginPolicyStore.createPolicyFromScratch();
  editPolicy(lp.id);
  showConfirmCreateDialog.value = false;
}

async function editPolicyAsNew(policyId: string) {
  const lp = await loginPolicyStore.createPolicyFromExisting(policyId);
  editPolicy(lp.id);
}

function editPolicy(policyId: string) {
  openReadOnly.value = false;
  selectedPolicyId.value = policyId;
}

function viewPolicy(policyId: string) {
  openReadOnly.value = true;
  selectedPolicyId.value = policyId;
}
</script>
